export default [
  {path: '/medication/select', component: () => import('../page/medicationquery/select')},
  {
    path: '/medication/list',
    component: () => import('../page/medicationquery/list'),
    children: [
      {path: ":idx", component: () => import('../page/medicationquery/idx')}
    ]
  },
  {
    path: '/medication/detail',
    component: () => import('../page/medicationquery/detail'),
  },
]



// WEBPACK FOOTER //
// ./src/router/medicationquery.js